import { Grid, Typography, Box, Button } from "@mui/material";
import { brandingConstants } from "../../PreviewStyles/constants";
import { handleFontPreview } from "../helpers";
import FeedbackButtons from "./Buttons/FeedbackButtons";
import QRButtons from "./Buttons/QRButtons";

interface IProps {
  previewAgent: boolean;
  branding: any;
  technology: string | undefined;
  page: number;
  addQR: boolean;
}

const FooterPreview = ({
  previewAgent,
  branding,
  technology,
  page,
  addQR,
}: IProps) => {
  let tempMarginTop = "40px";

  if (page === 2) {
    tempMarginTop = "150px";
  }

  return (
    <Grid
      item
      container
      flexDirection="column"
      xs={12}
      mb={1}
      mt={previewAgent ? tempMarginTop : "20px"}
      flexBasis="unset"
      flex={(addQR && page === 5) || (!addQR && page === 4) ? 1 : "unset"}
      sx={{ flex: "1!important" }}
    >
      {page !== 5 && page !== 4 && (
        <FeedbackButtons
          previewAgent={previewAgent}
          branding={branding}
          technology={technology}
          page={page}
        />
      )}

      {page === 4 && addQR && (
        <QRButtons
          previewAgent={previewAgent}
          branding={branding}
          technology={technology}
          page={page}
        />
      )}

      <Grid container justifyContent="end" mt="auto">
        <Typography
          sx={{
            fontSize: previewAgent ? 12 : 5,
            color: "#04000054",
          }}
        >
          <span
            style={{
              color: branding?.[brandingConstants.inputLabelColor],
              opacity: 0.5,
            }}
          >
            Powered by
          </span>{" "}
          <b>
            <span
              style={{
                color: branding?.[brandingConstants.inputLabelColor],
                opacity: 0.5,
              }}
            >
              Cuvo
            </span>
          </b>{" "}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default FooterPreview;
